module.exports = __webpack_public_path__ + "static/media/zoomy6_preview.edd9f9ed.jpg";